(function () {
  // Adds a full-value RRP strikethrough (product compare-at + free gift value,
  // + express shipping RRP for subscriptions) to the UpCart drawer checkout button,
  // matching the PDP add-to-cart button.
  if (window.__hdcCartStrike) return;
  window.__hdcCartStrike = true;

  var SHIPPING_RRP_PENCE = 395; // Free Express Shipping (RRP £3.95) — subscription perk
  var productCache = {};

  function money(p) {
    return '£' + (p / 100).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function getProduct(handle) {
    if (!productCache[handle]) {
      productCache[handle] = fetch('/products/' + handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return productCache[handle];
  }

  async function computeAnchor() {
    var cart = await fetch('/cart.js').then(function (r) { return r.json(); });
    var anchor = 0;
    var hasSub = false;
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if (it.selling_plan_allocation) hasSub = true;
      var rrp = it.original_price || 0;
      var prod = await getProduct(it.handle);
      if (prod && prod.variants) {
        for (var j = 0; j < prod.variants.length; j++) {
          var v = prod.variants[j];
          if (v.id === it.variant_id) {
            if (v.compare_at_price && v.compare_at_price > rrp) rrp = v.compare_at_price;
            if (v.price && v.price > rrp) rrp = v.price;
            break;
          }
        }
      }
      anchor += rrp * it.quantity;
    }
    if (hasSub) anchor += SHIPPING_RRP_PENCE;
    return { anchor: anchor, total: cart.total_price };
  }

  var scheduled = false;
  var applying = false;

  async function apply() {
    scheduled = false;
    if (applying) return;
    var host = document.getElementById('upCart');
    var sr = host && host.shadowRoot;
    if (!sr) return;
    var els = sr.querySelectorAll('a, button');
    var link = null;
    for (var i = 0; i < els.length; i++) {
      if (/checkout/i.test(els[i].textContent)) { link = els[i]; break; }
    }
    if (!link) return;
    applying = true;
    try {
      var data = await computeAnchor();
      if (data.anchor > data.total && data.total > 0) {
        var key = data.anchor + ':' + data.total;
        if (link.dataset.hdcStrike !== key || !link.querySelector('s')) {
          var m = link.textContent.replace(/\s+/g, ' ').match(/Checkout\s*[•·:]?\s*(£[\d.,]+)\s*$/i);
          var shown = m ? m[1] : money(data.total);
          link.dataset.hdcStrike = key;
          link.innerHTML = 'Checkout • <s style="opacity:.7;font-weight:400;">' + money(data.anchor) + '</s> ' + shown;
        }
      }
    } catch (e) { /* noop */ }
    applying = false;
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    setTimeout(apply, 250);
  }

  function watch() {
    var host = document.getElementById('upCart');
    if (host && host.shadowRoot && !host.__hdcObserved) {
      host.__hdcObserved = true;
      new MutationObserver(schedule).observe(host.shadowRoot, { childList: true, subtree: true, characterData: true });
      schedule();
    }
  }

  new MutationObserver(watch).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  }
  watch();
})();
